module.exports = __webpack_public_path__ + "img/brand-icon4.21066b6b.jpg";